/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function () {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);

    if (href.startsWith('#qa') && !target.hasClass('is-on')) {
      setTimeout(function(){
        target.children('button').trigger('click');
      }, 500)
    }

    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

//スライダー
$(function () {
  $('.p-info__slider ul').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      // fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: true,
      dots: false,
      infinite: false
    });
  });
});

//フェード
$(function () {
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function (index, el) {
    var t = $(this);

    setTimeout(function () {
      $(window).on('resize scroll', function (event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if (h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if (sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if (d) {
        pointD = d;
      }

      if (pointH < pointSc) {
        setTimeout(function () {
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if (nextStr) {
        var nextArr = nextStr.split(' ');
        if (nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if (nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if (nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if (nextDelay) {
                step = delay;
              }
              if (nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function (index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function () {
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});


$(function () {
  if($('.p-fixbtn')[0]) {
    function toggleTestButton() {
      $('.p-fixbtn').toggleClass('is-on', $(window).scrollTop() + $(window).innerHeight() / 2 >= $('.js-fixPoint').offset().top);
    }

    $(window).on('scroll resize', toggleTestButton);
    toggleTestButton();
  }
});

$(function () {
  $('.nonmember-cam__preBtn > button, .member-cam__preBtn > button').on('click', function () {
    const $btn = $(this);
    $btn.toggleClass('is-on');
    $btn.next('div').stop(true, true).slideToggle();
  });
});

$(function () {
  $('.nonmember-cam__detail button.-more, .member-cam__detail button.-more').on('click', function () {
    const $btn = $(this);
    $btn.hide();
    $btn.next('ul').stop(true, true).slideToggle();
  });
});

$(function () {
  $('.nonmember-faq__qa dt button, .member-faq__qa dt button').on('click', function () {
    const $dt = $(this).closest('dt');
    $dt.toggleClass('is-on');
    $dt.next('dd').stop(true, true).slideToggle();
  });
});

// 商品説明（スマホのみ開閉）
$(function () {
  const mediaQuery = window.matchMedia('(max-width: 991px)');

  function updateProductText() {
    const $texts = $('.member-prod__itemMore').next('.member-prod__itemTxt');
    if (mediaQuery.matches) {
      $texts.hide();
      $('.member-prod__itemMore > button').removeClass('is-on');
    } else {
      $texts.show();
      $('.member-prod__itemMore > button').removeClass('is-on');
    }
  }

  $('.member-prod__itemMore > button').on('click', function () {
    if (!mediaQuery.matches) return;

    $(this).toggleClass('is-on');
    $(this).closest('.member-prod__itemMore').next('.member-prod__itemTxt').stop(true, true).slideToggle();
  });

  updateProductText();
  mediaQuery.addEventListener('change', updateProductText);
  let previousWidth = window.innerWidth;
  $(window).on('resize', function () {
    const currentWidth = window.innerWidth;
    if (currentWidth === previousWidth) return;
    previousWidth = currentWidth;
    updateProductText();
  });
});


//スライダー
$(function () {
  $('.member-month__slider ul').each(function () {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      // fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: true,
      variableWidth: true,
      centerMode: true,
      // responsive: [
      //   {
      //     breakpoint: 991,
      //     settings: {
      //       centerMode: false
      //     }
      //   }
      // ]
    });
  });
});

$(function () {
  $('.member-month__historyBtn').on('click', function () {
    $(this).toggleClass('is-on');
    $(this).next('.member-month__historyList').stop(true, true).slideToggle();
  });

  $('.member-month__historyBtn2').on('click', function () {
    $(this).toggleClass('is-on');
    $(this).next('.member-month__historyCon').stop(true, true).slideToggle();
  });
});

